// extracted by mini-css-extract-plugin
export default {"container":"ModalWrapper_container__Jtqq-","dim":"ModalWrapper_dim__TN7iB","modal":"ModalWrapper_modal__TRAqg","show":"ModalWrapper_show__ozOnh"};